import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, Observable } from 'rxjs';
import { Entity, View } from '../../../../shared/store/view/types';
import { Router } from '@angular/router';
import { SubHeaderService } from '../../../../shared/store/subheader/subheader.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { ViewService } from '../../../../shared/store/view/views.service';
import { FormService } from '../../../../shared/store/form/form.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SalesTeamModel } from '../../../../shared/store/sales-team/types';
import { SalesTeamService } from '../../../../shared/store/sales-team/sales-team.service';
import { take } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-sales-team-create',
  templateUrl: './sales-team-create.component.html',
  styleUrls: ['./sales-team-create.component.scss'],
  standalone: false,
})
export class SalesTeamCreateComponent implements OnInit, OnDestroy {
  view$: Observable<View>;
  salesTeamForm: FormGroup;
  createSalesTeamInstance: Observable<SalesTeamModel>;

  protected readonly Entity = Entity;

  constructor(
    private readonly salesTeamService: SalesTeamService,
    private readonly router: Router,
    private readonly subHeaderService: SubHeaderService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly viewService: ViewService,
    private readonly formService: FormService,
    private readonly formBuilder: FormBuilder,
  ) {
    this.view$ = this.viewService.getViews.value$;
    this.createSalesTeamInstance = this.salesTeamService.create.value$;
  }

  ngOnInit(): void {
    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'salesTeamCreate') this.onSubmit();
        if (x == 'salesTeamList') {
          this.formService.clear();
          this.router.navigate(['Crm/SalesTeams/']);
        }
        this.subHeaderService.setTriggerAction('');
      });

    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@list', x.title);
        this.breadcrumbService.set('@salesTeamCreate', x.breadcrumbCreate);
      });

    this.salesTeamForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      code: [''],
      teamLeaderId: [undefined],
      notes: [''],
      active: [true],
    });

    this.salesTeamService.create.call();
    this.createSalesTeamInstance
      .pipe(
        filter((x) => !!x),
        untilDestroyed(this),
      )
      .subscribe((x) => {
        this.salesTeamForm?.patchValue({
          name: x.name,
          code: x.code,
          active: x.active,
          teamLeaderId: x.teamLeaderId,
        });
      });
  }

  onSubmit() {
    if (this.salesTeamForm.invalid) {
      this.salesTeamForm.markAllAsTouched();
      this.formService.countErrors(this.salesTeamForm, true);
      return;
    }

    let result$ = this.salesTeamService.postSalesTeam.call({
      active: this.salesTeamForm.value.active!,
      code: this.salesTeamForm.value.code!,
      name: this.salesTeamForm.value.name!,
      teamLeaderId: this.salesTeamForm.value.teamLeaderId,

      //others
      id: 0,
      notes: '',
      teamLeaderContactName: '',
      parentId: null,
      parentName: '',
      salesTeamMembers: [],
      contactId: 0,
      contactName: '',
    });

    result$
      .pipe(
        filter((x) => !!x),
        take(1),
      )
      .subscribe((result) => {
        this.formService.clear();
        this.router.navigate(['/Crm/SalesTeams/Details', result.id]);
      });
  }

  ngOnDestroy(): void {
    this.salesTeamService.postSalesTeam.reset();
  }
}
